// src/Components/DailyReminders/DailyReminders.js
import React from 'react';
import { Typography, Box, Card, CardContent } from '@mui/material';

const DailyReminders = () => {
  const reminders = [
    ["When was the last time you prayed? Go Pray and Repent."],
    ["Repent for your sins."],
    ["Turn to Allah before you return to Allah."],
    ["Did you recite Surah Kahf or any Surah today?"],
    ["Recite Surah Mulk if you want to be saved from Azzab-e-Qabr."],
    ["Recite the Quran daily to refresh your Iman."],
    ["Did you do Dhikr today?"]
  ];

  // Function to get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
  const getCurrentDay = () => {
    const today = new Date().getDay();
    return today;
  };

  // Function to get reminders based on the current day
  const getRemindersForDay = () => {
    const currentDay = getCurrentDay();

    // If it's Friday, show 4 reminders
    
    // For other days, show the single reminder for the day
    return [reminders[currentDay]];
  };

  return (
    <Box sx={{ marginTop: '10px', textAlign: 'center',height:'fit-content', Width: '98%',marginLeft:'10px',marginRight:'10px' }}>
      <Card style={{ backgroundColor: 'goldenrod', padding: '10px', Width: '98%',marginLeft:'10px',marginRight:'10px', margin: 'auto' }}>
        <CardContent>
        <Typography variant="h3" sx={{ color: 'darkslategrey', marginBottom: '10px',fontWeight:'bold', fontFamily: 'Cinzel Decorative' }}>
        Daily Reminders
      </Typography>
          {getRemindersForDay().map((reminder, index) => (
            <Typography key={index} variant="h6" sx={{ color: 'black', marginBottom: '10px', fontWeight:'lighter',fontStyle:'italic' }}>
              {reminder}
            </Typography>
          ))}
        </CardContent>
      </Card>
    </Box>
  );
};

export default DailyReminders;
